import theme from 'config/theme';

export default {
  wrapper: (disabled = false) => ({
    position: 'relative',
    padding: '40px',
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '32px',
    marginBottom: '12px',
    ...(disabled && {
      pointerEvents: 'none',
      cursor: 'not-allowed',
      ':after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: '#fff',
        opacity: 0.6,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      },
    }),
  }),
  smallWrapper: {
    padding: '32px',
  },
  embeddedWrapper: {
    padding: 0,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '32px',
    svg: {
      cursor: 'pointer',
    },
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '1.25rem',
    fontWeight: 700,
    color: theme.palette.grays.gray700,
    lineHeight: 1,
    svg: {
      path: {
        fill: theme.palette.grays.gray700,
      },
    },
  },
  embeddedTitle: {
    fontSize: '1.125rem',
    fontWeight: 600,
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
};
